export default __webpack_public_path__ + "static/media/ic_cod.0dbd79e8.svg";